<template>
  <v-container style="height:100%; background-color:#222;">
    <v-layout xs12 column wrap justify-center>
        <v-flex xs12 fluid style="margin-bottom:15px">
          <v-icon style="font-size:24px;color:#bf975f;">fas fa-user</v-icon><span class="pl-2 ml-2" style="font-size:13px; text-transform:uppercase;color:#bf975f">USER</span>
        </v-flex>
        <v-layout row xs12>
          <v-flex xs3>
            <span style="font-size:13px; text-transform:uppercase;">Type :</span>
            <!-- <v-select class="pa-2" dark v-model="selectedType" :items="types" persistent-hint return-object @input="selectType"></v-select> -->
            <span style="font-size:13px; text-transform:uppercase;">{{ selectedType }}</span>
          </v-flex>
        </v-layout>
          <v-flex v-if="selectedType === 'Verbal'">
            <v-flex x12 class="my-4">
              <v-layout column>
                <v-flex class="mb-4" style="font-size:15px; text-transform:uppercase;">
                  Anticipated User Response
                </v-flex>
                <v-flex>
                  <v-layout row  wrap   style="float:left">
                    <v-flex shrink v-for="(keyword, i) in keywords" :key="i">
                        <v-chip outline text-color="rgb(255,255,255,0.5)" @click="removeKeyword(keyword)" close style="float:left;">
                          {{keyword.value}}
                        </v-chip>
                        <span style="float:bottom;color:#9FA8DA">{{similarityScores[i]}}</span>
                          <!--  <v-flex>
                            <v-btn small @click="removeKeyword(keyword)">close</v-btn>
                          </v-flex> -->
                    </v-flex>
                  </v-layout>
                  <v-flex class="pa-3" style="color:rgb(255,255,255,0.4)" v-if="!keywords.length">
                        Empty
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs7>
              <span style="font-size:15px; text-transform:uppercase;">Add Ancitipated User Responses</span>
              <v-layout row>
                <v-text-field class="pr-2 pl-r pt-2" dark v-model="keywordInput" label="Keywords"></v-text-field>
                <v-layout row style="float:bottom">
                  <v-btn color="#bf975f" dark round @click="addKeyword">Add</v-btn>
                  <v-btn color="#bf975f" dark round @click="enableSynonymDialog">Synonym</v-btn>
                  <v-btn v-if="simiLoading" loading disabled color="#bf975f" dark round @click="similarityCheckAll">Similarity</v-btn>
                  <v-btn v-else color="#3F51B5" dark round @click="similarityCheckAll">Similarity</v-btn>
                </v-layout>
              </v-layout>
            </v-flex>
            <v-flex xs2></v-flex>
        </v-flex>


        <v-flex v-if="selectedType === 'Non-Verbal'">
            <v-flex style="font-size:13px; text-transform:uppercase;">
              Conditional Combinations
            </v-flex>
              <v-flex v-for="(condition, i) in conditions" :key="i">
                <v-flex class="mt-3" style="font-size:13px; text-transform:uppercase;">
                 Condition {{i+1}}
                </v-flex>
                <user-panel-condition
                  v-bind:condition="condition"
                  v-bind:userConditionItems="editor.userConditionItems"
                  v-bind:visualItems="visualItems"
                ></user-panel-condition>
              </v-flex>


              <v-btn @click="addCondition" dark depressed>
                <v-icon left>add</v-icon>
                Add Condition
              </v-btn>
        </v-flex>
    </v-layout>
      <!-- <similarity-dialog
    :showSimilarityDialog="showSimilarityDialog"
    @closeSimilarityDialog="closeSimilarityDialog"
    :editor="editor"
  >
  </similarity-dialog> -->
  </v-container>
</template>
<script>
import uniqid from 'uniqid'
import fuzz from 'wordfuzz'
import SimilarityDialog from '../user-class/similarityDialog'
import UserPanelCondition from '../story-edit-view/userPanelCondition'
import * as use from '@tensorflow-models/universal-sentence-encoder'

export default {
  props: ['currentNode', 'editor'],
  components: {
    similarityDialog: SimilarityDialog,
    UserPanelCondition: UserPanelCondition
  },
  data () {
    return {
      selectedType: this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'type').value,
      keywords: [],
      types: ['Verbal', 'Non-Verbal'],
      visualItems: this.editor.userConditionItems.filter(userConditionItem => userConditionItem.section === 'photo'),
      conditions: [],
      keywordInput: '',
      // showSimilarityDialog: false,
      simiLoading: false,
      similarityScores: []
    }
  },
  mounted () {
    const keywords = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'keywords')
    keywords.value = keywords.value || []
    this.keywords = keywords.value

    const conditions = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'conditions')
    conditions.value = conditions.value || []
    this.conditions = conditions.value
  },
  watch: {
    currentNode () {
      this.selectedType = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'type').value

      const keywords = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'keywords')
      keywords.value = keywords.value || []
      this.keywords = keywords.value

      let conditions = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'conditions')
      conditions.value = conditions.value || []
      this.conditions = conditions.value

      this.keywordInput = ''
      this.similarityScores = []
      // this.showSimilarityDialog = false
    }
  },
  methods: {
    similarityCheckAll () {
      this.similarityScores = []
      this.simiLoading = true
      const keywordList = [...this.keywords]
      const len = keywordList.length
      const input = this.keywordInput
      for (let i = 0; i < len; i++) {
        this.simiLoading = true
        use.load().then(model => {
          // Embed an array of sentences.
          const sentences = [
            keywordList[i].value,
            input
          ]
          model.embed(sentences).then(embeddings => {
            // embeddings.print(true /* verbose */)
            const sentenceX = embeddings.slice([0, 0], [1])
            const sentenceY = embeddings.slice([1, 0], [1])
            const sentenceITranspose = false
            const sentenceJTransepose = true
            const score =
              sentenceX.matMul(sentenceY, sentenceITranspose, sentenceJTransepose)
                  .dataSync()
            // this.theScore = parseFloat(score).toFixed(2) * 100 + '% ' + 'similar to your input'
            console.log(i + ':' + parseFloat(score).toFixed(2) * 100 + '%')
            this.similarityScores.push(parseFloat(score).toFixed(2) * 100 + '%')
            this.simiLoading = false
          })
        })
      }
    },
    selectType (value) {
      const selectedValue = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'type')
      selectedValue.value = value
      // if (value === 'Non-Verbal') {
      //   this.editor.signals.userNodeTypeChanged.dispatch()
      // }
    },
    removeKeyword (value) {
      this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'keywords').value = this.keywords.filter(keyword => keyword !== value)
      this.keywords = this.currentNode.data.selectedValues.find(selectedValue => selectedValue.key === 'keywords').value
    },
    addKeyword () {
      if (this.keywordInput !== '' && !this.keywords.find(keyword => keyword.value.toLowerCase() === this.keywordInput.toLowerCase())) {
        this.keywords.push({
          key: 'keyword',
          value: this.keywordInput,
          id: uniqid()
        })
        this.keywordInput = ''
      }
    },
    addCondition () {
      this.conditions.push(
        {
          type: 'Verbal',
          scaleValue: [0, 0],
          stringValue: '',
          selectionValue: '',
          booleanValue: true,
          visualItem: '',
          visualItemType: '',
          id: uniqid()
        }
      )
    },
    enableSynonymDialog () {
      // copied from user tab
      fuzz()
        .meansLike(this.keywordInput)
        .ask()
        .then(res => {
          if (res.length !== 0) {
            let wordsList = []
            for (let i = 0; i < 6; i++) {
              wordsList.push(res[i].word)
            }
            this.editor.signals.enableSynonymDialog.dispatch(wordsList)
            console.log(wordsList)
          } else {
            console.log(this.keywordInput + ' does NOT have synonyms')
          }
        })
    },
    enableSimilarityDialog () {
      this.editor.signals.sendKeywordInput.dispatch(this.keywordInput)
      this.showSimilarityDialog = true
    },
    closeSimilarityDialog (e) {
      this.showSimilarityDialog = e
    }
  }
}
</script>
<style lang="stylus" scoped>
  .flex {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/story-edit-view/userPanel.vue